export const fontWeights = {
  regular: 400,
  medium: 500,
  semiBold:600,
  bold: 700,
};

export const fontSizes = {
  verySmall: "0.5rem" /*"8px"*/,
  small: "0.625rem" /*"10px"*/,
  caption: "0.75rem" /*"12px"*/,
  button: "0.875rem" /*"14px"*/,
  smallBody: "1rem" /*"16px"*/,
  body: "1.125rem" /*"18px"*/,
  smallTitle: "1.25rem" /*"20px"*/,
  title: "1.38rem" /*"22px"*/,
  h5: "1.5rem" /*"24px"*/,
  h4: "1.625rem" /*"26px"*/,
  h3:"1.875rem" /*"30px"*/,
  h2: "2.1875rem" /*"35px"*/,
  h1:"2.5rem" /*"40px"*/,
};
